// import { useEffect, useState } from "react";

// const OfferPopup = () => {
//   const [show, setShow] = useState(false);

//   useEffect(() => {
//     const isShown = localStorage.getItem("offerShown");

//     if (!isShown) {
//       setTimeout(() => {
//         setShow(true);
//         localStorage.setItem("offerShown", "true");
//       }, 1500); // delay for smooth UX
//     }
//   }, []);

//   if (!show) return null;

//   return (
//     <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center px-4">
      
//       {/* Popup Box */}
//       <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 relative animate-scaleIn">
        
//         {/* Close Button */}
//         <button
//           onClick={() => setShow(false)}
//           className="absolute top-3 right-3 text-gray-500 hover:text-black text-xl"
//         >
//           ✕
//         </button>

//         {/* Content */}
//         <div className="text-center">
//           <h2 className="text-xl md:text-2xl font-bold mb-2">
//             🎉 Special Offer!
//           </h2>

//           <p className="text-sm md:text-base text-gray-600 mb-4">
//             Get up to <span className="font-semibold text-green-600">30% OFF</span> on refurbished laptops
//           </p>

//           <button className="bg-black text-white px-5 py-2 rounded-full hover:bg-gray-800 transition">
//             Shop Now
//           </button>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default OfferPopup;
import { useEffect, useState } from "react";

const OfferPopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isShown = localStorage.getItem("offerShown");

    if (!isShown) {
      setTimeout(() => {
        setShow(true);
        localStorage.setItem("offerShown", "true");
      }, 1500); // delay for smooth UX
    }
  }, []);

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center px-4">
      
      {/* Popup Box */}
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 relative animate-scaleIn">
        
        {/* Close Button */}
        <button
          onClick={() => setShow(false)}
          className="absolute top-3 right-3 text-gray-500 hover:text-black text-xl"
        >
          ✕
        </button>

        {/* Content */}
        <div className="text-center">
          <h2 className="text-xl md:text-2xl font-bold mb-2">
            🎉 Special Offer!
          </h2>

          <p className="text-sm md:text-base text-gray-600 mb-4">
            Get up to <span className="font-semibold text-green-600">30% OFF</span> on refurbished laptops
          </p>

          <button className="bg-black text-white px-5 py-2 rounded-full hover:bg-gray-800 transition">
            Shop Now
          </button>
        </div>

      </div>
    </div>
  );
};

export default OfferPopup;